import types from './InventoryLogType';

/**
 * Человекочитаемые заголовки событий ленты. Ключ — код события.
 *
 * Незнакомый код заголовка не имеет: лента показывает description с бэкенда, а если и его
 * нет — сам код. Так новые типы событий не ломают уже выкаченный фронт.
 */
export default class InventoryLogTypeTitle {
    static [types.ITEM_CREATED] = 'Оборудование заведено';
    static [types.ITEM_UPDATED] = 'Данные изменены';
    static [types.ITEM_DELETED] = 'Оборудование удалено';

    // Легаси-код, встречается только в записях до перехода на держателей.
    static [types.ITEM_RESPONSIBLE_CHANGED] = 'Материально ответственный изменён';

    static [types.ITEM_HOLDER_CHANGED] = 'Ответственный изменён';
    static [types.ITEM_STATUS_CHANGED] = 'Статус изменён';

    static [types.ITEM_ATTRIBUTE_CREATED] = 'Атрибут добавлен';
    static [types.ITEM_ATTRIBUTE_UPDATED] = 'Атрибут изменён';
    static [types.ITEM_ATTRIBUTE_DELETED] = 'Атрибут удалён';

    static [types.ITEM_FILE_ATTACHED] = 'Файл прикреплён';
    static [types.ITEM_FILE_DELETED] = 'Файл удалён';
    static [types.ITEM_FILE_PRIMARY_SET] = 'Главное фото назначено';
    static [types.ITEM_FILE_PRIMARY_CLEARED] = 'Главное фото снято';
}
